const customStyles = (
  borderColor: string,
): Record<string, (styles: React.CSSProperties, state?: any) => React.CSSProperties> => ({
  control: (styles: React.CSSProperties, state: any) => ({
    ...styles,
    background: 'transparent',
    borderRadius: 0,
    border: '2px solid rgba(255, 255, 255, 0.4)',
    boxShadow: 'none',
    borderColor: state.isFocused && borderColor,
    '&:hover': {
      borderColor: '#C4C4C4',
    },
  }),
  menu: (styles: React.CSSProperties) => ({
    ...styles,
    borderRadius: 0,
    marginTop: '4px',
    boxShadow: '0px 4px 12px rgba(8, 46, 181, 0.12)',
    zIndex: 100,
  }),
  menuList: (styles: React.CSSProperties) => ({
    ...styles,
    padding: '8px 0',
  }),
  valueContainer: (styles: React.CSSProperties, state: any) => ({
    ...styles,
    padding: '16.5px 12px',
    opacity: state.selectProps.menuIsOpen ? 1 : 0.7,
    '&:hover': {
      opacity: 1,
    },
  }),
  dropdownIndicator: (styles: React.CSSProperties, state: any) => ({
    ...styles,
    transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
    transition: '0.3s ease',
    padding: '0 16px',
  }),
  option: (styles: React.CSSProperties, state: any) => ({
    ...styles,
    color: (state.isSelected && '#000000!important') || (state.isFocused && '#000000!important') || '#323232!important',
    fontWeight: (state.isSelected && '700') || (state.isFocused && '500') || '400',
    background: 'transparent',
    padding: '12px 16px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    label: {
      color:
        (state.isSelected && '#000000!important') || (state.isFocused && '#000000!important') || '#323232!important',
      '&:hover': {
        cursor: 'pointer',
      },
    },
  }),
  singleValue: (styles: React.CSSProperties) => ({
    ...styles,
    overflow: 'visible',
  }),
  multiValue: (styles: React.CSSProperties) => ({
    ...styles,
    backgroundColor: '#transparent',
  }),
  multiValueRemove: (styles: React.CSSProperties) => ({
    ...styles,
    ':hover': {
      backgroundColor: '#FF04D5',
    },
  }),
  groupHeading: (styles: React.CSSProperties) => ({
    ...styles,
    color: '#000000!important',
    fontSize: '14px',
    fontWeight: '500',
    textTransform: 'none',
  }),
  placeholder: (styles: React.CSSProperties) => ({
    ...styles,
    color: '#ffffff!important',
  }),
});

export default customStyles;
